import { toEmbedUrl } from "@/lib/videoEmbed";
import RichText, { stripHtml } from "@/components/RichText";

// Valeurs par défaut identiques à theme_service.DEFAULT_PROPS["video"] — voir
// HeroSection.jsx pour l'explication du repli. Contrairement à
// VideoBannerSection (vidéo en fond, plein cadre), ici la vidéo est le
// contenu principal, dans un lecteur contenu (aspect-video).
const DEFAULTS = {
  heading: "",
  video_url: "",
  autoplay: "false",
  loop: "false",
};

export default function VideoSection({ props = {} }) {
  const t = { ...DEFAULTS, ...props };
  const autoplay = t.autoplay === "true" || t.autoplay === true;
  const loop = t.loop === "true" || t.loop === true;
  const embed = toEmbedUrl(t.video_url, { autoplay, loop });

  if (!embed) return null;

  return (
    <section className="max-w-[900px] mx-auto px-6 py-section md:py-section-md">
      {t.heading && (
        <RichText
          as="h2"
          className="font-display font-semibold text-[28px] md:text-[32px] leading-tight tracking-[-0.02em] text-ink mb-6 text-center"
          html={t.heading}
        />
      )}
      <div className="relative aspect-video rounded-2xl overflow-hidden bg-ink">
        {embed.kind === "iframe" ? (
          <iframe
            src={embed.src}
            title={stripHtml(t.heading) || "Vidéo"}
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            className="absolute inset-0 w-full h-full"
          />
        ) : (
          <video
            src={embed.src}
            autoPlay={autoplay}
            loop={loop}
            muted={autoplay}
            playsInline
            controls
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
      </div>
    </section>
  );
}
